<template>
    <div class="button-container--rules">
    <v-btn
      class="header-buttons-menu-mobile"
      outlined
      @click.stop="dialog = true"
    >
      Правила
    </v-btn>

    <v-dialog
      v-model="dialog"
      max-width="690"
    >
      <v-card>
        <v-card-title class="headline">Правила</v-card-title>
        <v-card-text>
            <p>Один користувач може проголосувати за учасника, який найбільше сподобався, лише один раз. При цьому можно обрати декількох учасників. 
            Голосування триватиме до 27 червня 20:00. </p>
            <p>Детальніше про умови конкурсу STEEL HIT читайте за посиланням:</p>
            <a href="https://cutt.ly/fyDjXZ5"  style="color: #ff3700">https://cutt.ly/fyDjXZ5</a>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        dialog: false,
      }
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/Modals/ModalRules.vue